<style lang="scss">
@import '$vars';

.file-history {
  @apply my-3 pt-3;
  border-top: 1px solid rgb(225, 225, 225);

  &__title {
    @apply text-base text-grayDark;
    font-family: $font1;
    font-weight: 600;
  }

  &__not-found {
    @apply text-base text-grayDark text-left pt-4;
    font-weight: 500;
  }

  &__list {
    @apply flex flex-row flex-wrap items-center justify-start;
  }

  &__file {
    @apply p-2 mr-4 mb-4;
    @apply self-stretch flex flex-row items-center justify-start relative;
    background: rgb(244, 244, 244);
    width: 30%;

    @screen sm {
      @apply w-full;
    }
  }

  &__icon {
    @apply cursor-pointer;
    width: 40px;

    img {
      height: 100%;
      width: auto;
    }
  }

  &__description {
    @apply cursor-pointer;
  }

  &__type {
    @apply text-grayDark mb-0;
    font-family: $font1;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: capitalize;
  }

  &__date {
    @apply text-grayDark;
    font-size: 0.65rem;
  }

  &__signed {
    @apply absolute cursor-pointer;
    right: -2%;
    top: -10%;

    &-tooltip {
      @apply absolute p-1;
      background: #666666;
      border-radius: 3px;
      bottom: calc(100% + 10px);
      color: #ffffff;
      right: 0;
      text-align: center;
      font-size: 0.65rem;
      font-weight: 600;
      width: 220px;

      &:after {
        content: '';
        border: 5px solid transparent;
        border-top-color: #666666;
        display: block;
        position: absolute;
        top: 100%;
        right: 10px;
      }

      &--green {
        background: rgb(84, 221, 132);
        right: 0;
        width: 150px;

        &:after {
          border-top-color: rgb(84, 221, 132);
          right: 10px;
        }
      }
    }
  }

  &__remove {
    align-items: center;
    background: $color-red;
    border-radius: 50%;
    bottom: 100%;
    color: white;
    cursor: pointer;
    display: flex;
    font-size: 0.55rem;
    font-weight: normal;
    justify-content: center;
    left: -10px;
    height: 1rem;
    padding: 0;
    position: absolute;
    top: -10px;
    width: 1rem;
    transition: all ease 0.5s;

    &:hover {
      background: darken($color-red, 10%);
      transition: all ease 0.5s;
    }

    i {
      margin: 0;
      padding: 0;
    }
  }
}

.modal-footer {
  span {
    display: flex;
    width: max-content;
  }
}
</style>

<template>
  <section class="file-history">
    <h2 class="file-history__title">Histórico</h2>

    <div class="file-history__wrapper">
      <dr-loader
        v-if="ui.loading"
        size="lg"
        class="file-history__loader"
      />

      <template v-if="!ui.loading && files.length === 0">
        <p class="file-history__not-found">
          {{ notFoundMsg }}
        </p>
      </template>

      <template v-if="!ui.loading && files.length > 0">
        <div class="file-history__list">
          <div
            v-for="file in files"
            :key="`file-history-file-${file.id}`"
            :class="{ 'pointer-events-none': ui.loadingFile }"
            class="file-history__file"
            @mouseenter="canDeleteFile(file.agenda.id) && (file.showRemove = true)"
            @mouseleave="canDeleteFile(file.agenda.id) && (file.showRemove = false)"
          >
            <transition
              name="fade"
              mode="out-in"
            >
              <div
                v-if="file.showRemove"
                class="file-history__remove"
                @click="confirmDelete(file.id)"
              >
                <i class="icon icon-cross" />
              </div>
            </transition>

            <div
              class="file-history__icon"
              @click="openFile(file)"
            >
              <img src="@/assets/img/pdf.png" />
            </div>

            <div
              class="file-history__description"
              @click="openFile(file)"
            >
              <h5 class="file-history__type">
                {{ route.label }}
              </h5>

              <div class="file-history__date">
                {{
                  'created_at' in file
                    ? $moment(file['created_at']).format('DD/MM/YYYY')
                    : $moment(file['date']).format('DD/MM/YYYY')
                }}
              </div>

              <div
                class="file-history__signed"
                @mouseenter="file.showTooltip = true"
                @mouseleave="file.showTooltip = false"
              >
                <dr-icon
                  class="w-8"
                  :name="Boolean(file['signed_file']) ? 'verifiedDoc' : 'verifiedDocGray'"
                  fill="transparent"
                />

                <transition
                  name="fade"
                  mode="out-in"
                >
                  <div
                    v-if="file.showTooltip"
                    :class="{ 'file-history__signed-tooltip--green': file['signed_file'] }"
                    class="file-history__signed-tooltip"
                  >
                    {{
                      file['signed_file']
                        ? 'Assinado digitalmente'
                        : 'Não assinado digitalmente ou em processo de assinatura digital'
                    }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <print-template
      v-if="currentFile"
      :active.sync="currentFile"
      :patient.sync="patientData"
      :type="type"
      @cancel="currentFile = null"
    />

    <!-- Modal PDF -->
    <div
      v-show="ui.showFile"
      :id="`modal-id-${_uid}`"
      :class="{ 'active': ui.showFile}"
      class="modal modal-lg"
    >
      <span
        aria-label="Close"
        class="modal-overlay"
        @click="removeEmbed()"
      />

      <div class="modal-container">
        <div class="modal-header">
          <span
            aria-label="Close"
            class="btn btn-clear float-right"
            @click="removeEmbed()"
          />

          <div class="modal-title h5 capitalize">
            {{ route.label }}
          </div>
        </div>

        <div class="modal-body">
          <div
            id="pdf__container"
            class="content"
          />
        </div>

        <div class="modal-footer">
          <span
            class="btn btn-primary btn-sm"
            @click="removeEmbed()"
          >
            Fechar
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'
import printTemplate from '@/components/templates/print/'

export default {
  name: 'FileHistory',

  props: {
    type: {
      type: String,
      required: true,
      validator: (type) => {
        return ['sicknote', 'exam', 'prescription', 'file'].includes(type)
      }
    },

    appointmentId: {
      type: Number,
      required: false,
      default: () => null
    },

    appointmentDate: {
      type: String,
      required: false,
      default: () => null
    },

    isActiveAppointment: {
      type: Boolean,
      required: false,
      default: () => false
    },

    isMedicalHistoryVisible: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  components: {
    printTemplate
  },

  data () {
    return {
      files: [],
      currentFile: null,
      patientData: null,
      ui: {
        showFile: false,
        loading: false,
        loadingFile: false
      },
      routes: [
        {
          type: 'sicknote',
          url: '/sick_note',
          filter: 'sn.agenda',
          order: 'sn.createdAt',
          label: 'atestado',
          article: 'o'
        },
        {
          type: 'exam',
          url: '/exam_request',
          filter: 'er.agenda',
          order: 'er.createdAt',
          label: 'pedido de exame',
          article: 'o'
        },
        {
          type: 'prescription',
          url: '/prescription',
          filter: 'p.agenda',
          order: 'p.createdAt',
          label: 'receita médica',
          article: 'a'
        },
        {
          type: 'prescriptionSpecial',
          url: '/prescription',
          filter: 'p.agenda',
          order: 'p.createdAt',
          label: 'receita médica',
          article: 'a'
        },
        {
          type: 'file',
          url: '/medical_document',
          filter: 'a.id',
          order: 'a.id',
          label: 'arquivo',
          article: 'o'
        }
      ]
    }
  },

  computed: {
    route () {
      return this.routes.find((route) => route.type === this.type)
    },

    url () {
      return `${this.route.url}${this.queryString}`
    },

    notFoundMsg () {
      return `${
        this.route.type === 'prescription' ? 'Nenhuma' : 'Nenhum'
      } ${
        this.route.label
      } ${
        this.route.type === 'prescription' ? 'encontrada' : 'encontrado'
      }.`
    },

    patient () {
      return {
        id: this.$route.params.id,
        type: this.$route.params.patientType
      }
    },

    queryString () {
      const patientType = this.patient.type === 'specialPatient' ? 'sp' : 'u'

      const params = [
        { query: `filterAnd[${this.route.filter}]`, value: this.appointmentId },
        { query: 'orientation', value: 'desc' },
        { query: `order[${this.route.order}]`, value: 'desc' },
        { query: 'itensPerPage', value: 'all' },
        { query: `filterAnd[${patientType}.id]`, value: this.patient.id }
      ]

      if (this.type === 'file') {
        params.pop()
      }

      if (this.type !== 'file' && this.isMedicalHistoryVisible) {
        params.shift()
      }

      return params.reduce((acc, item) => {
        if (item.value) {
          return acc === '?'
            ? `${acc}${item.query}=${item.value}`
            : `${acc}&${item.query}=${item.value}`
        }

        return acc
      }, '?')
    }
  },

  created () {
    this.init()

    EventBus.$on('reload-file-history', () => this.init())
  },

  methods: {
    init () {
      this.ui.loading = true
      this.fn_SHOW_PROGRESS()

      this.$http
        .get(this.url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.files = res.data.data
            .map((item) => ({ ...item, showTooltip: false, showRemove: false }))
        })
        .then(this.getPatient)
        .then((res) => (this.patientData = res.patient))
        .finally(() => {
          this.ui.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    getPatient () {
      const url = this.patient.type === 'specialPatient'
        ? `/doctor/special_patient/${this.patient.id}`
        : `/doctor/patient/${this.patient.id}`

      return new Promise(
        (resolve, reject) => this.$http.get(url, this.$store.getters.getAuthHeader)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      )
    },

    openFile (file) {
      if (file['file_name']) {
        this.embedFile(process.env.ROOT_API + process.env.DOCTOR_MEDICAL_DOCUMENT + file['file_name'])
        return
      }

      if (file['signed_file']) {
        this.getFile(file)
        return
      }

      this.currentFile = file
    },

    getFile (file) {
      const url = `${process.env.ROOT_API}/s3/file/${this.route.url.replace('/', '')}/${file.id}/signed_file`

      this.fn_SHOW_PROGRESS()
      this.ui.loadingFile = true

      this.$http
        .get(
          url,
          {
            headers: this.$store.getters.getAuthHeader.headers,
            responseType: 'blob'
          }
        )
        .then((res) => this.generatePDFFile(res.data))
        .then((objURL) => this.embedFile(objURL))
        .then((embed) => {
          if (embed) {
            this.ui.showFile = true
          }
        })
        .catch(err => console.trace(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.ui.loadingFile = false
        })
    },

    generatePDFFile (rawData) {
      const blob = new Blob([rawData], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },

    embedFile (file = null) {
      return new Promise((resolve, reject) => {
        if (file) {
          this.ui.showFile = true

          this.$nextTick()
            .then(() => {
              const wrapper = document.querySelector(`#modal-id-${this._uid} #pdf__container`)
              const embed = document.createElement('embed')
              embed.classList.add('pdf-file')
              embed.style.height = '70vh'
              embed.style.width = '100%'
              embed.setAttribute('src', file)
              wrapper.appendChild(embed)

              resolve()
            })

          return true
        }

        reject(new Error('erro'))
      })
    },

    removeEmbed () {
      const wrapper = document.querySelector(`#modal-id-${this._uid} #pdf__container`)
      const embed = wrapper.querySelectorAll('embed')

      for (let el of embed) {
        el.remove()
      }

      this.ui.showFile = false
    },

    confirmDelete (fileId) {
      const msg = `Tem certeza que deseja apagar
        ${this.route.article} ${this.route.label}? Essa ação não poderá ser desfeita.`

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: msg,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.deleteFile(fileId)
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    deleteFile (fileId) {
      const url = String(`${this.route.url}/${fileId}`).substring(1)

      let msg = `${this.route.label} removid${this.route.article} com sucesso`
      msg = msg.substring(0, 1).toUpperCase() + msg.substring(1)

      this.fn_SHOW_PROGRESS()
      this.ui.loadingFile = true
      this.$http
        .delete(url, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: msg,
            size: 'md',
            active: true
          })

          setTimeout(() => {
            this.$store.dispatch('setModalAlert', {
              active: false
            })
          }, 2000)

          this.init()
        })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.ui.loadingFile = false
        })
    },

    canDeleteFile (fileId) {
      const isSameDay = this.appointmentDate
        ? this.$moment().isSame(this.$moment(this.appointmentDate), 'day')
        : false

      return fileId === this.appointmentId && isSameDay
    }
  }
}
</script>
